<res-generic-grid [gridName]="gridName" [automationId]="automationId + '-grid'" [helpIndex]="helpIndex"
    [updateStatusType]="updateStatusType" [headerTemplate]="buttonBar" [columnDefs]="columnDefs" [requestInfo]="requestInfo"
    [contextMenuOptions]="contextMenuOptions" [responseArrayCallback]="responseArrayCallback"
    [cellDoubleClickedCallback]="cellDoubleClickedCallback" [rowClassRules]="rowClassRules">
</res-generic-grid>
<ng-template #buttonBar>
    <button type="button" data-automation-id="export-databases-new-button" class="secondary-button"
        (click)="newDatabase()" *ngIf="!hasDBViewOnlyPermissions">
        <i class="fa fa-plus"></i>New Database ...</button>
</ng-template>